var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAkarIconsCircleCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_911)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.99866 12.3412L10.9987 15.3412L15.9987 9.34125",
    stroke: "#48B7EF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9987 21.8413C17.5215 21.8413 21.9987 17.3641 21.9987 11.8412C21.9987 6.3184 17.5215 1.84125 11.9987 1.84125C6.47581 1.84125 1.99866 6.3184 1.99866 11.8412C1.99866 17.3641 6.47581 21.8413 11.9987 21.8413Z",
    stroke: "#48B7EF",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_911"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAkarIconsCircleCheck);
export default __webpack_public_path__ + "static/media/akar-icons_circle-check.3f4627ffdaa7210d11cfc6c80531ab1b.svg";
export { ForwardRef as ReactComponent };